import React, { useState, useEffect } from "react";
import axios from "axios";

import Button from "react-bootstrap/Button";
import "./ReportGen.css";
import { SubTopic } from "../pages/SubTopic";
import Spinner from "react-bootstrap/Spinner";
import Moment from "react-moment";
import { ProfileView } from "../pages/ProfileView";
import { SummaryView } from "../pages/SummaryView";
import { report } from "process";
import { SubTopicAlt } from "../pages/SubTopicAlt";

export const ReportGen = () => {
  const [subtopics, setSubTopics] = useState([]);
  const [presentationTitle, setPresentationTitle] = useState([]);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const queryParameters = new URLSearchParams(window.location.search);

  const [selectedIndex, setSelectedIndex] = useState(
    queryParameters.get("selected_index")
  );
  const [isShare, setIsShare] = useState(params.get("isShare"));

  const [reportId, setReportId] = useState(params.get("reportId"));
  const [partnerName, setPartnerName] = useState(params.get("partnerName"));
  const [partnerId, setPartnerId] = useState();
  const [owner, setOwner] = useState();
  const [updatedTime, setUpdatedTime] = useState();
  const [partnerData, setPartnerData] = useState();
  const [completedSubTopics, setCompletedSubTopics] = useState([]);
  const [subtopicComplete, setSubTopicComplete] = useState(false);
  const [summary, setSummary] = useState();
  const [overview, setOverview] = useState("");

  const audience = params.get("audience");
  const textLength = params.get("textLength");
  const content = params.get("content");
  const dateRange = params.get("dateRange");
  const queryContent = params.get("queryContent");
  // const partnerName = params.get("partnerName");
  // const partnerId = params.get("partnerId");
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );

  function onShare() {
    var currentUrl = window.location.href;
    currentUrl += "&isShare=true";
    navigator.clipboard.writeText(currentUrl);
    alert("Jam Copied to Clipboard");
  }

  function onCreateYourOwn() {
    window.location.href = "/createReport";
  }

  function onClickBackToCopilot() {
    window.location.href =
      "/outlineEditor?reportId=" +
      reportId +
      "&selected_index=" +
      selectedIndex;
  }
  useEffect(() => {
    if (reportId != undefined) {
      try {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/getReport",
            {
              reportId: reportId,
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            // setSubTopics([response.data.subtopics[3]]);
            setPartnerId(response.data.report.partner_id);

            setSummary(response.data.report.summary);

            setOverview(response.data.report.overview);

            setSubTopics(response.data.subtopics);

            var complateSubTopic = [];
            response.data.subtopics.forEach((sub) => {
              if (sub.generated_response != "") {
                complateSubTopic.push(sub);
              } else if (sub.prompt == "") {
                console.log("COMPLETED EMPTY");
                complateSubTopic.push(sub);
                completedSubTopics.push(sub);
              }
            });
            console.log(
              "LENGTH OF COMPLETE",
              complateSubTopic.length,
              response.data.subtopics.length
            );
            if (
              complateSubTopic.length == response.data.subtopics.length - 1 &&
              (response.data.report.summary == undefined ||
                response.data.report.summary == "")
            ) {
              console.log(
                "READY SUB TOPICS NO SUMMARY",
                summary,
                complateSubTopic.length,
                subtopics.length
              );
              setSummary(null);
              setCompletedSubTopics(complateSubTopic);
            }

            setOwner(response.data.owner);

            var isoTimestamp = response.data.report.timestamp.replace(" ", "T");
            isoTimestamp += "Z";
            const localDate = new Date(isoTimestamp);
            const localTimeString = localDate.toLocaleString();

            setUpdatedTime(localTimeString);

            setPresentationTitle(response.data.report.title);

            setPartnerData(response.data.partner);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error("Error processing message:", error);
      } finally {
      }
    }
  }, [reportId]);

  useEffect(() => {
    console.log(completedSubTopics.length, subtopics.length - 1, summary);
    if (
      completedSubTopics.length == subtopics.length - 1 &&
      completedSubTopics.length != 0 &&
      !summary
    ) {
      console.log("READY ALL DONE, SUMMARY TIME", completedSubTopics.length);

      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/generateSummary",
          {
            reportId: reportId,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log("SUMMARY RECEIVED", response.data.summary);
          setSummary(response.data.summary);
        });
    }
  }, [completedSubTopics, summary]);

  return (
    <div className="finalReportBackground">
      {" "}
      <ProfileView />
      {!isShare ? (
        <div>
          <Button
            onClick={onClickBackToCopilot}
            className="backButton"
            variant="light"
            size="sm"
          >
            Back To Outline Editor
          </Button>{" "}
          <Button
            onClick={onShare}
            className="backButton"
            variant="light"
            size="sm"
          >
            Share
          </Button>
        </div>
      ) : (
        <Button
          onClick={onCreateYourOwn}
          className="backButton"
          variant="light"
          size="sm"
        >
          Create Your Own
        </Button>
      )}
      {subtopics.length > 0 ? (
        <div className="viewReportContainer">
          <div className="reportTitle">
            {presentationTitle}{" "}
            {partnerData ? (
              <img className="profilePhoto" src={partnerData.icon} alt="" />
            ) : (
              <div></div>
            )}
            {overview ? (
              <div className="reportOverview">{overview}</div>
            ) : (
              <div></div>
            )}
            {owner ? (
              <div className="ownerBox">
                <img
                  className="profilePhoto"
                  src={owner.profile_photo}
                  alt=""
                />
                <div>
                  <div className="ownerName">
                    <b>By {owner.name}</b>
                  </div>
                  <div className="ownerName">
                    Last edited <Moment fromNow>{updatedTime}</Moment>
                  </div>
                  {partnerData ? (
                    <div className="ownerName">
                      Created for {partnerData.partner_name.replace("_", " ")}
                    </div>
                  ) : (
                    <div className="ownerName"></div>
                  )}
                </div>
              </div>
            ) : (
              <div className="ownerBox"></div>
            )}
          </div>
          {/* <div>
            <SummaryView
              summary={summary}
              setSummary={setSummary}
              reportId={reportId}
            />
          </div> */}

          {subtopics.map((report, index) => (
            <div>
              {report.is_summary ? (
                <div>
                  {" "}
                  <SummaryView
                    summary={summary}
                    setSummary={setSummary}
                    report={report}
                    reportId={reportId}
                    isShare={isShare}
                  />
                </div>
              ) : (
                <div>
                  {index % 2 == 0 && report.prompt != "" ? (
                    <SubTopicAlt
                      key={report.id}
                      report={report}
                      partnerId={partnerId}
                      partnerName={partnerName}
                      setCompletedSubTopics={setCompletedSubTopics}
                      completedSubTopics={completedSubTopics}
                      setReportId={setReportId}
                      numSubTopics={subtopics.length}
                      rowIndex={index}
                      isShare={isShare}
                    ></SubTopicAlt>
                  ) : report.prompt != "" ? (
                    <SubTopic
                      key={report.id}
                      report={report}
                      partnerId={partnerId}
                      partnerName={partnerName}
                      setCompletedSubTopics={setCompletedSubTopics}
                      completedSubTopics={completedSubTopics}
                      setReportId={setReportId}
                      numSubTopics={subtopics.length}
                      rowIndex={index}
                      isShare={isShare}
                    ></SubTopic>
                  ) : (
                    <div></div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="monitorLoader">
          <h2>Generating Your Jam</h2>
          <p>&nbsp;</p>

          <Spinner animation="border" variant="primary" />
        </div>
      )}
    </div>
  );
};

export default ReportGen;
